import { typographyClasses } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

/// Add themeName (default) in theme.ts
export const defaultPalette = {
  // hex color code can be used
  default: {
    fontFamily: ["Tinos", "serif"],
    typography: {
      allVariants: {
        fontFamily: ["Tinos", "serif"].join(","),
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
        @font-face {
        font-family:'Tinos',
        }
        `,
      },
    },
    light: {
      customColors: {
        clr1: "#F4AE4A",
        clr2: "#37211d",
        clr3: "#fdc472",
        //clr3: "#f0cd9e",
        subtabs: "#f5ca8c",
        content_header: "#ffdfb2",
      },
      primary: { main: "#37211D" },
      secondary: { main: "#efefef" },
      divider: "#ebebeb",
      background: {
        default: "#ffffff",
        paper: "#ffffff",
        secondary: "#FFFDF4",
      },
      text: {
        primary: "#000000",
        secondary: "#666666",
        disabled: blueGrey[400],
      },
      action: {
        active: "#f5d0d0",
        hover: "#f5d0d0",
        selected: "#f5d0d0",
        disabled: "#f5d0d0",
        disabledBackground: "#f5d0d0",
      },
    },
    dark: {
      customColors: {
        clr1: "#F4AE4A",
        clr2: "#37211d",
        clr3: "#fdc472",
      },
      primary: { main: "#4a4a4a" },
      secondary: { main: "#efefef" },
      divider: "#FF80AB",
      background: {
        default: "#2e2e2e",
        paper: "#2e2e2e",
        secondary: "#4a4a4a",
      },
      text: {
        primary: "#FFFFFF",
        secondary: "#ebebeb",
        disabled: "#9E9E9E",
      },
      action: {
        active: "#f5d0d0",
        hover: "#f5d0d0",
        selected: "#f5d0d0",
        disabled: "#f5d0d0",
        disabledBackground: "#f5d0d0",
      },
    },
  },
};
